// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { normalizeBallotId } from "@sequentech/ui-core";
var isHex = function (text) { return text.length % 2 === 0 && /^[0-9a-fA-F]+$/.test(text); };
// What a voter may type to find a ballot: the hash of the ballot, or the
// Ballot ID the ballot box signed for it. Nothing typed is not an error.
export var isBallotIdInput = function (input) {
    return input.trim() === "" || isHex(input) || normalizeBallotId(input) !== null;
};
// A ballot box's Ballot ID as the ballot box writes it; anything else as typed.
export var typedBallotId = function (input) { var _a; return (_a = normalizeBallotId(input)) !== null && _a !== void 0 ? _a : input; };
